export default __webpack_public_path__ + "static/media/resume.798097c8.pdf";